import React from 'react';

import CrossIcon from '../../../../assets/svgComponents/CrossIcon';
import MultiStateButton from '../redesign/multiStateButton/multiStateButton';
import SliderComponent from '../sliderComponent';
import ToastFailureIcon from '../../../../assets/svgComponents/ToastFailureIcon';
import ToastTickIcon from '../../../../assets/svgComponents/ToastTickIcon';

import VIDABOO_CONSTANTS from '../../../../config/consts';

import './toastComponent.css';

const ToastComponent = ({
  isSticky = false,
  toastExtraData = {},
  toastTitle = null,
  toastType = null,
  toastCustomBtnTxt = null,
  toastCustomBtnAction = null,
  onDismiss = () => {},
}) => {
  const toastSubTitleText = toastExtraData?.toastSubTitleText;
  const progressBarInfo = toastExtraData?.progressBarInfo;

  return (
    <div className="et-toast-container">
      <div
        className={`et-tc-animated-border ${toastType === VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS ? 'et-tc-success-border' : ''} ${toastType === VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE ? 'et-tc-failure-border' : ''}`}
      />
      <div className="et-tc-content-wrap">
        <div className="et-tc-content-row">
          <div>
            <div className="et-tc-icon-title-txt-wrap">
              {toastType ===
                VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS && (
                <div>
                  <ToastTickIcon />
                </div>
              )}
              {toastType ===
                VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE && (
                <div>
                  <ToastFailureIcon />
                </div>
              )}
              <div>
                <div className="et-tc-title-txt">
                  {toastTitle ?? 'Successfully saved'}
                </div>
                {toastSubTitleText && (
                  <div className="et-tc-sub-title-txt">{toastSubTitleText}</div>
                )}
              </div>
            </div>

            {progressBarInfo && (
              <div className="et-tc-slider-wrap">
                <SliderComponent
                  hideDot
                  defaultPercentage={progressBarInfo.percentage}
                />
              </div>
            )}
          </div>
          <div className="et-tc-btns-container">
            {toastCustomBtnTxt && (
              <div className="et-tc-custom-btn-wrap">
                <div className={`et-tc-animated-border`} />
                <div className="et-tc-custom-btn-container">
                  <MultiStateButton
                    isGhost
                    btnTxt={toastCustomBtnTxt}
                    onClick={() => {
                      toastCustomBtnAction();
                      onDismiss();
                    }}
                  />
                </div>
              </div>
            )}
            {isSticky && (
              <div className="et-tc-close-btn-wrap">
                <MultiStateButton
                  isGhost
                  leftImage={<CrossIcon />}
                  onClick={onDismiss}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToastComponent;
